import React from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

import temaFormulario from "../../Styles/Temas/temaFormulario";
import LoadingButton from "../LoadingButton";

export default function ModalConfirmacao({
    open = false,
    onConfirma = () => { },
    onCancela = () => { },
    confirmarText = "Prosseguir",
    confirmarTextComponent = null,
    cancelarText = "Cancelar",
    titulo = 'Atenção',
    texto = 'Deseja mesmo prosseguir?',
    textoComponent = null,
    isLoading = false
}) {
    return (
        <MuiThemeProvider theme={temaFormulario}>
            <Dialog
                open={open}
                onClose={onCancela}
                fullWidth
                aria-labelledby="modal-confirmacao"
                maxWidth={"sm"}
            >
                <DialogTitle id="modal-confirmacao">
                    {titulo}
                    <CloseIcon style={{ float: 'right', cursor: 'pointer' }} onClick={onCancela}>
                        <CloseIcon />
                    </CloseIcon>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ wordBreak: "break-word" }}>
                        {textoComponent !== null ? textoComponent : texto}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id="button_cancelar-confirmacao"
                        variant="text"
                        onClick={onCancela}
                        style={{color: 'gray'}}
                    >
                        {cancelarText}
                    </Button>
                    <LoadingButton
                        id="button_confirmar-confirmacao"
                        variant="text"
                        color='secondary'
                        loading={isLoading}
                        onClick={onConfirma}
                    >
                        {confirmarTextComponent ?? confirmarText}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </MuiThemeProvider>
    );
}
